import React from 'react';
import styled from 'styled-components';

interface IProps {
  setAgeConfirmed: React.Dispatch<React.SetStateAction<boolean>>;
}

const AgeConfirmation = (props: IProps): JSX.Element => {
  const { setAgeConfirmed } = props;
  return (
    <AgeConfirmationComponent>
      <ConsentText>To view this site you need to be 18 years or older</ConsentText>
      <ConsentButton onClick={(): void => setAgeConfirmed(true)}>I am 18 years or older</ConsentButton>
      <ConsentButton>I am not 18 years or older</ConsentButton>
    </AgeConfirmationComponent>
  );
};

export default AgeConfirmation;

const AgeConfirmationComponent = styled.div`
  display: grid;
  grid-template-rows: 50% 50%;
  grid-template-columns: 50% 50%;
  height: 50%;
  width: 50%;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.75);
  grid-template-areas: 'header header';

  @media (max-width: 768px) {
    display: grid;
    grid-template-rows: 50% 25% 25%;
    grid-template-columns: 100%;
    grid-template-areas: 'header';
  }
`;

const ConsentText = styled.div`
  grid-area: header;
  margin: auto;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const ConsentButton = styled.button`
  height: 2rem;
  width: 15rem;
  margin: auto;

  @media (max-width: 768px) {
    height: 100%;
    width: 100%;
  }
`;
